export default {
    "h1": {
        variant: "subtitle1",
        rowHeight: 40
    },
    "d0": {
        variant: "body2",
        rowHeight: 25
    },

    "d1": {
        variant: "body2",
        rowHeight: 25
    },
    "eol": {
        variant: "caption",
        rowHeight: 25
    },
};


// WEBPACK FOOTER //
// ./src/app/configuration/Discover/config/components/scorecard/MetricsLabels/rowTypeMap.js